import React from 'react';
import { useSelector } from 'react-redux';

import BuyNowPayLaterDetails from 'dpl/puppy_page/components/BuyNowPayLaterDetails';
import useToggle from 'dpl/shared/hooks/useToggle';
import PriceBreakdownModal from 'dpl/common/components/PriceBreakdownModal';
import { sendAnalyticsEvent } from 'dpl/util/analytics';
import {
  ANALYTICS_EVENTS,
  ANALYTICS_VIEW_FEATURE_LOCATIONS,
  ANALYTICS_VIEW_FEATURES,
  ANALYTICS_VIEWS
} from 'dpl/constants/analytics';

function PriceBreakdown() {
  const [isBreakdownVisible, toggleIsBreakdownVisible] = useToggle(false);

  const {
    acceptsBnplPayments,
    depositRefundPolicy,
    depositDescription,
    priceBreakdown,
    priceRangeDescription,
    includedExtrasParagraphs
  } = useSelector(({ server }) => server);

  function handleClick(e) {
    toggleIsBreakdownVisible();

    sendAnalyticsEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      button_cta: e.target.textContent,
      view: ANALYTICS_VIEWS.BREEDER_PROFILE,
      view_feature: ANALYTICS_VIEW_FEATURES.PRICE_BREAKDOWN_BUTTON,
      view_feature_location: ANALYTICS_VIEW_FEATURE_LOCATIONS.ABOUT_TAB
    });
  }

  return (
    <>
      <p className="font-16">
        {priceRangeDescription}{' '}
        {priceBreakdown && (
          <button
            type="button"
            className="font-16 fw-medium stone-700 underline"
            onClick={handleClick}
          >
            Price breakdown
          </button>
        )}
      </p>
      {priceBreakdown && (
        <PriceBreakdownModal
          deposit={priceBreakdown.deposit}
          depositDescription={depositDescription}
          depositRefundPolicy={depositRefundPolicy}
          dogPayment={priceBreakdown.dog_payment}
          subtotal={priceBreakdown.subtotal}
          includedExtrasParagraphs={includedExtrasParagraphs}
          isBnplAvailable={acceptsBnplPayments}
          isOpen={isBreakdownVisible}
          onClose={toggleIsBreakdownVisible}
        />
      )}
    </>
  );
}

export default function PuppyPricing() {
  const { acceptsBnplPayments, priceBreakdown } = useSelector(
    ({ server }) => server
  );

  return (
    <div className="PuppyPricing">
      <h4 className="font-24 lh-title pt2 mb6 w-90 mr2">Pricing</h4>
      <PriceBreakdown />
      {acceptsBnplPayments && priceBreakdown && (
        <div className="font-16 mt4">
          <p>
            Pay over time with Klarna.{' '}
            <BuyNowPayLaterDetails className="fw-medium stone-700" />
          </p>
        </div>
      )}
    </div>
  );
}
